/**
 * @generated SignedSource<<03d8e8a2b5a785166fa75b1f5e7c29df>>
 * @relayHash e8ab4e2e1c1e5bfc230660c30be888db
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e8ab4e2e1c1e5bfc230660c30be888db

import { ConcreteRequest } from 'relay-runtime';
export type Ch_findClosestPreventionCareProviderInput = {
  address: AddressInput;
  patientId: string;
  preventionProgramKey: string;
};
export type AddressInput = {
  city: string;
  countryCode: string;
  houseNumberStreet: string;
  postalCode: string;
};
export type chFindClosestPreventionCareProviderMutation$variables = {
  input: Ch_findClosestPreventionCareProviderInput;
};
export type chFindClosestPreventionCareProviderMutation$data = {
  readonly ch_findClosestPreventionCareProvider: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly findClosestPreventionCareProviderOutput: {
      readonly closestCareProviderId: string | null;
    } | null;
  };
};
export type chFindClosestPreventionCareProviderMutation = {
  response: chFindClosestPreventionCareProviderMutation$data;
  variables: chFindClosestPreventionCareProviderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "FindClosestPreventionCareProviderOutput",
  "kind": "LinkedField",
  "name": "findClosestPreventionCareProviderOutput",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closestCareProviderId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chFindClosestPreventionCareProviderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_findClosestPreventionCareProviderPayload",
        "kind": "LinkedField",
        "name": "ch_findClosestPreventionCareProvider",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chFindClosestPreventionCareProviderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_findClosestPreventionCareProviderPayload",
        "kind": "LinkedField",
        "name": "ch_findClosestPreventionCareProvider",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "e8ab4e2e1c1e5bfc230660c30be888db",
    "metadata": {},
    "name": "chFindClosestPreventionCareProviderMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e5bf89b9761e53e8959ce2abb114057f";

export default node;
